import { render, staticRenderFns } from "./AddStrategy.vue?vue&type=template&id=423830c6&scoped=true"
import script from "./AddStrategy.vue?vue&type=script&lang=js"
export * from "./AddStrategy.vue?vue&type=script&lang=js"
import style0 from "./AddStrategy.vue?vue&type=style&index=0&id=423830c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423830c6",
  null
  
)

export default component.exports